import { gql } from '@apollo/client';

/**
 * Spec 0011 (survey constructor) — ERP-scope queries. Operation names are
 * deliberately different from the backend field names (`surveys`, `survey`,
 * `groupSurveyAssignments`, …) to avoid the codegen result-type collapse.
 *
 * `questionType` is a plain String on the wire
 * (yes_no|text|rating|single_choice|multi_choice|nps); answer `value` is a
 * JSONString parsed only in the `core/hooks/Surveys` transform layer.
 */

export const SurveysListQuery = gql`
  query ErpSurveysList(
    $courseId: ID
    $includeArchived: Boolean
    $search: String
  ) {
    surveys(
      courseId: $courseId
      includeArchived: $includeArchived
      search: $search
    ) {
      id
      title
      courseId
      courseName
      defaultLessonNumber
      isArchived
      hasResponses
      questionsCount
      assignmentsCount
      updatedAt
    }
  }
`;

export const SurveyDetailQuery = gql`
  query ErpSurveyDetail($id: ID!) {
    survey(id: $id) {
      id
      title
      description
      courseId
      courseName
      defaultLessonNumber
      isArchived
      hasResponses
      questions {
        id
        number
        text
        questionType
        required
        options
      }
    }
  }
`;

export const GroupSurveyAssignmentsQuery = gql`
  query ErpGroupSurveyAssignments($groupId: ID!) {
    groupSurveyAssignments(groupId: $groupId) {
      id
      surveyId
      surveyTitle
      lessonId
      lessonName
      lessonNumber
      lessonDate
      isActive
      respondedCount
      eligibleCount
    }
  }
`;

export const SurveyAssignmentResultsQuery = gql`
  query ErpSurveyAssignmentResults($assignmentId: ID!) {
    surveyAssignmentResults(assignmentId: $assignmentId) {
      assignment {
        id
        surveyTitle
        groupId
        groupName
        lessonName
        lessonNumber
        respondedCount
        eligibleCount
      }
      respondents {
        studentId
        fullName
        email
        responded
        submittedAt
        responseId
      }
      questionResults {
        question {
          id
          number
          text
          questionType
          required
          options
        }
        answersCount
        average
        distribution {
          key
          label
          count
        }
      }
    }
  }
`;

export const SurveyResponseDetailQuery = gql`
  query ErpSurveyResponseDetail($responseId: ID!) {
    surveyResponseDetail(responseId: $responseId) {
      responseId
      studentId
      fullName
      submittedAt
      answers {
        questionId
        value
      }
    }
  }
`;
